export const blockIconsPlacesSportsBar = (
	<span className='material-symbols-outlined'>sports_bar</span>
);
